module.exports = __webpack_public_path__ + "img/NA.f7e66053.png";